import { Component, inject } from '@angular/core';
import { DistanceRangeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DistanceRangeCreateDto,
  DistanceRangeDto,
  DistanceRangeExcelDownloadDto,
  DistanceRangeUpdateDto,
} from '../proxy/general/dtos/distance-range';
import { DISTANCERANGE_CONFIG, DISTANCERANGE_FIELDS } from './distance-range.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-distance-range',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DistanceRangeService, ConfirmationService],
  templateUrl: './distance-range.html',
  styleUrl: './distance-range.scss',
})
export class DistanceRange extends BaseCrudComponent<
  DistanceRangeDto,
  DistanceRangeCreateDto,
  DistanceRangeUpdateDto,
  DistanceRangeExcelDownloadDto
> {
  service = inject(DistanceRangeService);
  config = DISTANCERANGE_CONFIG;
  fields = DISTANCERANGE_FIELDS;

  protected prepareUpdateDto(data: any, selected: DistanceRangeDto): DistanceRangeUpdateDto {
    return {
      name: data.name,
      endDistanceId: data.endDistanceId,
      startDistanceId: data.startDistanceId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'DistanceRange';
  }
}
